import { render, staticRenderFns } from "./BaoCaoXepLoaiDN.vue?vue&type=template&id=2289cba4&scoped=true"
import script from "./BaoCaoXepLoaiDN.vue?vue&type=script&lang=ts"
export * from "./BaoCaoXepLoaiDN.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2289cba4",
  null
  
)

export default component.exports